:host{display:flex;flex-direction:row;flex:1}.content{display:flex;flex-direction:column;flex:1}
/*# sourceMappingURL=words.component-NANPZIPQ.css.map */
